import React from 'react';
import Store from '../../store/Store';

export interface LinkProps {
    to?: string;
    href?: string;
    target?: string;
    rel?: string;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
    children?: React.ReactNode;
    id?: string;
    ['data-pw']?: string;
    className?: string;
}

export const Link: React.FC<LinkProps> = props => {
    return props.to ? (
        <a
            id={props.id}
            data-pw={props['data-pw'] ?? props.id}
            className={props.className ?? "app-link"}
            href={props.to}
            onClick={(e) => {
                e.preventDefault();
                if (props.onClick) props.onClick(e);
                Store.navigate(props.to!);
            }}
        >
            {props.children}
        </a>
    ) : (
        <a
            id={props.id}
            data-pw={props['data-pw'] ?? props.id}
            className={props.className ?? "app-link"}
            href={props.href ?? props.to}
            target={props.target ?? '_blank'}
            rel={props.rel ?? "noopener noreferrer"}
            onClick={props.onClick}
        >
            {props.children}
        </a>
    );
};
